export default "__VITE_ASSET__D3Y0C39n__"